import React, {useEffect, useState} from 'react';
import ProductsManager from "../managers/productsManager/productsManager";
import {Trans} from "react-i18next";
import {Accordion, AccordionDetails, AccordionSummary, Typography} from "@mui/material";
import ProductPromoEditor from "./Components/ProductPromoEditor";
import ProductPromoManager from "../managers/productPromoManager/productPromoManager";
import {ArrowDownward} from "@mui/icons-material";
import PromoCodeEditor from "./Components/PromoCodeEditor";
import Button from "@mui/material/Button";
import {useNavigate} from "react-router";

function PromotionsPage(props) {
    const [products, setProducts] = useState({});
    const [promotion, setPromotion] = useState({});
    const navigate = useNavigate();

    const fetchData = async () => {
        const data = await ProductsManager.getAllProducts(true);
        setPromotion(await ProductPromoManager.getAllPromotion());
        setProducts({...data});
    };

    useEffect(() => {
        fetchData();
    }, []);

    const onProductPromoChange = (key, value) => {
        ProductPromoManager.saveProductPromo(key, value, async () => {
            setPromotion(await ProductPromoManager.getAllPromotion());
        });
    }

    const onCodeChange = (value) => {
        ProductPromoManager.saveCodes(value, async () => {
            setPromotion(await ProductPromoManager.getAllPromotion());
        });
    }

    const onSingleUseCodeChange = (value) => {
        ProductPromoManager.saveSingleUseCodes(value, async () => {
            setPromotion(await ProductPromoManager.getAllPromotion());
        });
    }

    const onPersonalPickupChange = (value) => {
        ProductPromoManager.savePersonalPickupCode(value, async () => {
            setPromotion(await ProductPromoManager.getAllPromotion());
        });
    }

    return (
        <div className="promotionspage">
            <Button sx={{mt: 2}} color={'secondary'} onClick={() => navigate('/admin')}>&lt; <Trans i18nKey={'buttons.back'}/></Button>
            <Accordion>
                <AccordionSummary
                    expandIcon={<ArrowDownward/>}
                    aria-controls="panel1-content"
                    id="panel1-header"
                >
                    <Typography>
                        Codes
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <PromoCodeEditor obj={promotion?.codes || {}} onChange={onCodeChange}/>
                </AccordionDetails>
            </Accordion>
            <Accordion>
                <AccordionSummary
                    expandIcon={<ArrowDownward/>}
                    aria-controls="panel1-content"
                    id="panel1-header"
                >
                    <Typography>
                        Single Use Codes
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <PromoCodeEditor obj={promotion?.singleUseCodes || {}} onChange={onSingleUseCodeChange}/>
                </AccordionDetails>
            </Accordion>
            <Accordion>
                <AccordionSummary
                    expandIcon={<ArrowDownward/>}
                    aria-controls="panel1-content"
                    id="panel1-header"
                >
                    <Typography>
                        Personal pickup
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <PromoCodeEditor obj={promotion?.personalPickup || {}} onChange={onPersonalPickupChange}/>
                </AccordionDetails>
            </Accordion>
            <Accordion>
                <AccordionSummary
                    expandIcon={<ArrowDownward/>}
                    aria-controls="panel1-content"
                    id="panel1-header"
                >
                    <Typography>
                        Products
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>

                    {Object.keys(products).map(key => <Accordion>
                            <AccordionSummary
                                expandIcon={<ArrowDownward/>}
                                aria-controls="panel1-content"
                                id="panel1-header"
                            >
                                <Typography component="span"><Trans i18nKey={products[key].name}/></Typography>
                                {promotion?.products?.[key] ?
                                    <Typography component="span" color={'red'} sx={{pl: 3, fontWeight: 500}}>&lt;- On
                                        sale</Typography> : ''}

                            </AccordionSummary>
                            <AccordionDetails>
                                <ProductPromoEditor obj={promotion?.products?.[key]}
                                             onChange={(value) => onProductPromoChange(key, value)}/>
                            </AccordionDetails>
                        </Accordion>
                    )}
                </AccordionDetails>
            </Accordion>
        </div>
    );
}

export default PromotionsPage;
